export default __webpack_public_path__ + "static/media/Websites- Camera 2.0a53c219.png";